import { render, staticRenderFns } from "./WorkOrderForm2.vue?vue&type=template&id=5b226bd9&scoped=true"
import script from "./WorkOrderForm2.vue?vue&type=script&lang=js"
export * from "./WorkOrderForm2.vue?vue&type=script&lang=js"
import style0 from "./WorkOrderForm2.vue?vue&type=style&index=0&id=5b226bd9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b226bd9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSlider } from 'vuetify/lib/components/VSlider';
installComponents(component, {VAutocomplete,VCol,VRadio,VRadioGroup,VRow,VSlider})
